import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { logout } from "../Redux/Actions/AuthActions";
import logo from "../image/LOGOTASKOPOS1.png";
import "./NavAuth.css";

const NavAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const user = useSelector((state) => state.AuthReducer?.user);
  const token = useSelector((state) => state.AuthReducer?.token);

  if (!token || !user) {
    return null;
  }

  const handleLogout = () => {
    dispatch(logout());
    navigate("/Welcome");
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <Navbar
        bg="dark"
        variant="dark"
        fixed="top"
        className="tasko-navbar"
        expand="lg"
        expanded={isMobileMenuOpen}
      >
        <Container fluid>
          {/* Logo — notre logo dans le bouton bleu */}
          <Navbar.Brand as={Link} to="/Welcome" onClick={closeMobileMenu} className="d-flex align-items-center">
            <img
              src={logo}
              alt="TASKO POS"
              className="tasko-navbar-logo"
            />
          </Navbar.Brand>

          {/* Bouton hamburger personnalisé */}
          <button
            className={`tasko-hamburger-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Menu"
          >
            <span className="tasko-hamburger-lines">
              <span className="tasko-line"></span>
              <span className="tasko-line"></span>
              <span className="tasko-line"></span>
            </span>
          </button>

          <Navbar.Collapse id="tasko-navbar-nav">
            <Nav className="tasko-nav-menu">
              {token && user ? (
                <>
                  {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace' || user.role === 'userspintoss') && (
                    <NavDropdown title="Demandes Produits" id="demandes-dropdown" className="tasko-nav-dropdown">

                      {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace' || user.role === 'userspintoss') && <NavDropdown.Item as={Link} to="/ProductRequest" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Demande Produits
                      </NavDropdown.Item>}
                      {(user.role === 'admin' || user.role === 'useradmin') && <NavDropdown.Item as={Link} to="/CentralizedRequests" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Centralisation Demandes
                      </NavDropdown.Item>}
                      {user.role === 'admin' && <NavDropdown.Item as={Link} to="/AdminApproval" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Approbation Admin
                      </NavDropdown.Item>}
                      {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'usertwinpark' || user.role === 'userbagngo') && <NavDropdown.Item as={Link} to="/PurchaseList" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Liste d'Achat
                      </NavDropdown.Item>}
                    </NavDropdown>
                  )}

                  {(user.role === 'admin' || user.role === 'useradmin') && (
                    <NavDropdown title="Admin" id="admin-dashboard-dropdown" className="tasko-nav-dropdown">
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/Home" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          DashBoard
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/AdvancedAnalytics" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Analytics Avancés
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/MargeState" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Etat de la Marge
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/GlobalDashbord" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Chiffre d'affaires
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/AddChargeExp" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Charges d'exploitation
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/EtatDepenses" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          État des Dépenses
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/Rbe" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Recap RBE
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/StockDetails" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Aperçu du Stock
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/ticketpersonnel" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Consommation Personnel
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/DeclarationEmployeur" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Déclaration Employeur
                        </NavDropdown.Item>
                      )}
                    </NavDropdown>
                  )}

                  {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'userwellness' || user.role === 'usertwinpark' || user.role === 'userspintoss') && (
                    <NavDropdown title="Rapports" id="rapports-dropdown" className="tasko-nav-dropdown">
                      {(user.role === 'admin' || user.role === 'userwellness') && (
                        <NavDropdown.Item as={Link} to="/AddRapports" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Rapports Wellness
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin') && (
                        <NavDropdown.Item as={Link} to="/ListRapport" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Listes des Rapports Wellness
                        </NavDropdown.Item>
                      )}
                      
                      <NavDropdown.Divider />
                      
                      {(user.role === 'admin' || user.role === 'usertwinpark') && (
                        <NavDropdown.Item as={Link} to="/AddRapportsTwin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Rapports Twin Park
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin') && (
                        <NavDropdown.Item as={Link} to="/ListeRapportTwin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Listes des Rapports Twin Park
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'usertwinpark') && (
                        <NavDropdown.Item as={Link} to="/CollecteTwin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Collecte Twin Park
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin') && (
                        <NavDropdown.Item as={Link} to="/ListeCollecteTwin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Listes des Collectes Twin Park
                        </NavDropdown.Item>
                      )}

                      <NavDropdown.Divider />

                      {(user.role === 'admin' || user.role === 'userspintoss') && (
                        <NavDropdown.Item as={Link} to="/AddRapportsSpintoss" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Rapports Spintoss
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin') && (
                        <NavDropdown.Item as={Link} to="/ListRapportsSpintoss" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Listes des Rapports Spintoss
                        </NavDropdown.Item>
                      )}
                      <NavDropdown.Divider />
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/DeclarationEmployeur" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📄 Déclaration Employeur
                        </NavDropdown.Item>
                      )}
                    </NavDropdown>
                  )}

                  {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace' || user.role === 'userspintoss') && (
                    <NavDropdown title="ABONNEMENTS" id="rapports-dropdown" className="tasko-nav-dropdown">
                      <NavDropdown.Item as={Link} to="/Event" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Actions Marketing
                      </NavDropdown.Item>

                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/Pack" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Gestion des packages
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userespace' || user.role === 'userspintoss') && (
                        <NavDropdown.Item as={Link} to="/Checkin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Verification pack
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/SubscribersList" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Liste des abonnées
                        </NavDropdown.Item>
                      )}
                    </NavDropdown>
                  )}

                  {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace') && (
                    <Nav.Link as={NavLink} to="/Valises" end onClick={closeMobileMenu} className="tasko-nav-link">
                      Caisse
                    </Nav.Link>
                  )}

                  {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace') && (
                    <Nav.Link as={NavLink} to="/TicketCaisse" onClick={closeMobileMenu} className="tasko-nav-link">
                      Rapport de caisse
                    </Nav.Link>
                  )}


                  {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace' || user.role === 'userspintoss') && (
                    <NavDropdown title="RESERVATION" id="rapports-dropdown" className="tasko-nav-dropdown">
                      <NavDropdown.Item as={Link} to="/SalonBookingModule" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Réservation salon
                      </NavDropdown.Item>


                      {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userespace' || user.role === 'userspintoss') && (
                        <NavDropdown.Item as={Link} to="/BookingCalendar" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Calendrier des Réservations
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/BookingHistory" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Historique des Réservations
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/ServiceManager" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          Creation des Services
                        </NavDropdown.Item>
                      )}


                    </NavDropdown>
                  )}



                  {(user.role === 'admin' || user.role === 'useradmin') && (
                    <NavDropdown title="FACTURES ET PRODUITS" id="produits-dropdown" className="tasko-nav-dropdown">
                      <NavDropdown.Header>GESTION DES PRODUITS</NavDropdown.Header>
                      <NavDropdown.Item as={Link} to="/CreaValises" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Création Produits
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/DealsV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Création des deals
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/UpdateProduct" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Modification Produits
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/CategoryProductManager" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Cathégorie et Produits WF
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/PointsGestionT" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Gestion des points
                      </NavDropdown.Item>



                      <NavDropdown.Header>GESTION DES FACTURES</NavDropdown.Header>

                      <NavDropdown.Item as={Link} to="/AjoutFrsV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Ajouter un fournisseur
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/AjoutFactureV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Ajouter une facture
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/ListFactureV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Liste des factures
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}

                  {(user.role === 'admin' || user.role === 'useradmin') && (
                    <NavDropdown title="Gestion du Stock" id="stock-dropdown" className="tasko-nav-dropdown">
                      <NavDropdown.Header>GESTION DE STOCK</NavDropdown.Header>
                      <NavDropdown.Item as={Link} to="/ApercuStock" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Etat du Stock
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/UpdateStockV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Modif Stock
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/ChangeLocation" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Changement de Localisation
                      </NavDropdown.Item>

                      {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace') && (
                        <NavDropdown.Header>SCANNAGE FACTURE</NavDropdown.Header>)}

                      <NavDropdown.Item as={Link} to="/UploadInvoice" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Telechargement
                      </NavDropdown.Item>
                      {(user.role === 'admin' || user.role === 'useradmin') && (<NavDropdown.Item as={Link} to="/InvoiceDocList" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Listing des factures
                      </NavDropdown.Item>)}
                      {user.role === 'admin' && (<NavDropdown.Item as={Link} to="/InvoiceView" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Aperçu des facture
                      </NavDropdown.Item>)}
                    </NavDropdown>

                  )}

                  {/* ── Statistiques ── */}
                  <NavDropdown title="📊 Statistiques" id="statistiques-dropdown" className="tasko-nav-dropdown">
                    {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'userwellness') && (
                      <NavDropdown.Item as={Link} to="/Statistiques/Wellness" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Wellness
                      </NavDropdown.Item>
                    )}
                    {(user.role === 'admin' || user.role === 'usertwinpark') && (
                      <NavDropdown.Item as={Link} to="/Statistiques/Twinpark" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Twinpark
                      </NavDropdown.Item>
                    )}
                    {(user.role === 'admin' || user.role === 'userbagngo') && (
                      <NavDropdown.Item as={Link} to="/Statistiques/Bagngo" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Bagn'Go
                      </NavDropdown.Item>
                    )}
                    {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'userespace') && (
                      <NavDropdown.Item as={Link} to="/Statistiques/Espace" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        E-space
                      </NavDropdown.Item>
                    )}
                    {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'userspintoss') && (
                      <NavDropdown.Item as={Link} to="/Statistiques/Spintoss" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Spintoss
                      </NavDropdown.Item>
                    )}
                  </NavDropdown>

                  <NavDropdown title="Profil" id="admin-profile-dropdown" className="tasko-nav-dropdown">
                    {user.role === 'admin' && (
                      <NavDropdown.Item as={Link} to="/Register" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Register
                      </NavDropdown.Item>
                    )}
                    {user.role === 'admin' && (
                      <NavDropdown.Item as={Link} to="/AllUser" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        Tous les utilisateurs
                      </NavDropdown.Item>
                    )}
                    <NavDropdown.Item as={Link} to="/UpdateProfil" onClick={closeMobileMenu} className="tasko-dropdown-item">
                      Mot de passe
                    </NavDropdown.Item>
                  </NavDropdown>

                  <Nav.Link onClick={handleLogout} className="tasko-nav-link tasko-logout-link">
                    Déconnexion
                  </Nav.Link>
                </>
              ) : (
                <>
                  <Nav.Link as={Link} to="/Welcome" onClick={closeMobileMenu} className="tasko-nav-link">
                    Welcome TASKO POS
                  </Nav.Link>
                  <Nav.Link as={Link} to="/Login" onClick={closeMobileMenu} className="tasko-nav-link">
                    Login
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Overlay pour mobile */}
      {isMobileMenuOpen && (
        <div className="tasko-mobile-overlay" onClick={closeMobileMenu}></div>
      )}
    </>
  );
};

export default NavAuth;